import React, { useCallback, useMemo, useState } from 'react';
import styled from 'styled-components';
import { useRouteMatch } from 'react-router-dom';

import { useAppContext } from '../../hooks';

import Layout from '../Layout';
import Header from '../Header';
import HeaderButton from '../HeaderButton';

import SignupForm from './SignupForm';
import SignupFormStep1 from './SignupFormStep1';
import SignupFormStep2 from './SignupFormStep2';
import SignupFormStep3 from './SignupFormStep3';
import SignupFormStep4 from './SignupFormStep4';
import StepIndicator from './StepIndicator';

const FeatureList = styled.ul`
  font-size: 2rem;
  list-style-type: '✓';
  margin: 0;
  padding: 0;

  & > li {
    margin-bottom: 1rem;
    margin-left: 1em;
    padding-inline-start: 1rem;
  }
}
`;

function Signup() {
  const { config, queryParams } = useAppContext();
  const isSignupSuccess = !!useRouteMatch('/signup/success');
  const initialStep = useMemo(() => {
    if (isSignupSuccess) {
      return 4;
    }
    const { form_errors, non_field_errors } = config;
    if (
      non_field_errors.length > 0 ||
      form_errors.email ||
      form_errors.first_name ||
      form_errors.last_name ||
      form_errors.notification_phone ||
      form_errors.terms_of_service_accepted
    ) {
      return 3;
    }
    if (
      queryParams.social_register ||
      form_errors.facility_name ||
      form_errors.city ||
      form_errors.street ||
      form_errors.country ||
      form_errors.phone ||
      form_errors.website
    ) {
      return 2;
    }
    return 1;
  }, [config, queryParams, isSignupSuccess]);
  const [step, setStep] = useState(initialStep);
  const handleNextStep = useCallback(() => setStep(step + 1), [step]);
  return (
    <Layout
      header={
        <Header
          prompt={i18n.gettext('You already have an account?')}
          button={
            <HeaderButton to="/signin">{i18n.gettext('Sign in')}</HeaderButton>
          }
        />
      }
      sidebar={
        <FeatureList>
          <li>{i18n.gettext('30-day free trial')}</li>
          <li>{i18n.gettext('No risk, no obligations')}</li>
          <li>{i18n.gettext('No payment data necessary')}</li>
          <li>
            {i18n.gettext('Receive reservations and orders automatically')}
          </li>
        </FeatureList>
      }
    >
      <StepIndicator
        step={step}
        numSteps={4}
        onStep={(nextStep) => {
          if (nextStep === 1) {
            window.location.href = '/signup';
            return;
          }
          setStep(nextStep);
        }}
      />
      <SignupForm>
        {step === 1 && <SignupFormStep1 onNextStep={handleNextStep} />}
        {step === 2 && <SignupFormStep2 onNextStep={handleNextStep} />}
        {step === 3 && <SignupFormStep3 />}
        {step === 4 && <SignupFormStep4 />}
      </SignupForm>
    </Layout>
  );
}

export default Signup;
